export function allLlmIssuesComplete(issues) {
  return issues
    .filter(issue => issue.trigger_type === "LLM" && issue.llm_meta)
    .every(({llm_meta}) => llm_meta.is_complete);
}
